import './measurements.css'

import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

function Measurement_sel_page({typeM, setSection, setUseSection, isMobile, info}) {
    const navigate = useNavigate()

    return (
    <div className={`FIT_W FIT_H`} style={{background: '#f9fafb', minHeight: '100vh', paddingTop: '100px', width: '100%'}}>
        <div style={{textAlign:"center", marginBottom: '40px', padding: '0 20px', width: '100%'}}>
            <h1 style={{fontFamily: 'var(--font-heading)', fontSize: '3rem', color: '#14213D', marginBottom: '10px', fontWeight: '600'}}>Measurements made Easy for you</h1>
            <p style={{color: '#666', maxWidth: '600px', margin: '0 auto', fontFamily: 'var(--font-body)', fontSize: '1rem'}}>Choose how you'd like to share your measurements — quick, simple, and accurate.</p>
        </div>

        <div className={`m_page0`} style={{width: '100%'}}>
            <div className='m_page0_wrapper' style={{maxWidth: '100%', padding: '0 5%'}}>
                <div className="m_page0_row">
                    
                    {/* Custom Measurements Card */}
                    <div className="m_page0_row_card m_card_custom"
                        onClick={()=>{
                            navigate(`/measurement/${"custom"}/${info}`)
                            if(typeM){ setSection(1) }else{ setUseSection(1) }
                        }}
                    >  
                        <div className="m_card_top">
                            {/* Ruler Icon */}
                            <svg className="m_card_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 1 0 2.828 2.828l14.504-12.19z"></path>
                                <path d="m9 22 3-3"></path>
                                <path d="m13 18 3-3"></path>
                                <path d="m17 14 3-3"></path>
                            </svg>
                        </div>
                        <div className='m_card_bottom'> 
                            <div className='m_card_title'>Custom Measurements</div>
                            <div className='m_card_desc'>Measuring for your perfect fit has never been easier.</div>
                            <button className="m_card_btn">Select</button>
                        </div>
                    </div>

                    {/* Size Chart Card */}
                    <div className="m_page0_row_card m_card_size"
                        onClick={()=>{
                            navigate(`/measurement/${"size_chart"}/${info}`)
                            if(typeM){ setSection(2) }else{ setUseSection(2) }
                        }}
                    >   
                        <div className="m_card_top">
                            {/* Shirt Icon */}
                            <svg className="m_card_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20.38 3.46L16 2a4 4 0 01-8 0L3.62 3.46a2 2 0 00-1.34 2.23l.58 3.47a1 1 0 00.99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 002-2V10h2.15a1 1 0 00.99-.84l.58-3.47a2 2 0 00-1.34-2.23z"></path>
                            </svg>
                        </div>
                        <div className='m_card_bottom'> 
                            <div className='m_card_title'>Choose from Size Chart</div>
                            <div className='m_card_desc'>Easily find your ideal fit with our detailed size chart.</div>
                            <button className="m_card_btn">Select</button>
                        </div>
                    </div>

                    {/* Saved Measurements Card */}
                    <div className="m_page0_row_card m_card_saved"
                        onClick={()=>{
                            navigate(`/measurement/${"saved"}/${info}`)
                            if(typeM){ setSection(3) }else{ setUseSection(3) }
                        }}
                    >   
                        <div className="m_card_top">
                            {/* Document/List Icon */}
                            <svg className="m_card_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                <polyline points="14 2 14 8 20 8"></polyline>
                                <line x1="16" y1="13" x2="8" y2="13"></line>
                                <line x1="16" y1="17" x2="8" y2="17"></line>
                                <polyline points="10 9 9 9 8 9"></polyline>
                            </svg>
                        </div>
                        <div className='m_card_bottom'> 
                            <div className='m_card_title'>Saved Measurements</div>
                            <div className='m_card_desc'>Reuse your saved measurements from previous orders for a seamless shopping experience.</div>
                            <button className="m_card_btn">Select</button>
                        </div>
                    </div>

                    {/* Clone a Cloth Card */}
                    <div className="m_page0_row_card m_card_clone"
                        onClick={()=>{
                            navigate(`/measurement/${"clone"}/${info}`)
                            if(typeM){ setSection(4) }else{ setUseSection(4) }
                        }}
                    >   
                        <div className="m_card_top">
                            {/* Gift/Box Icon */}
                            <svg className="m_card_icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 12 20 22 4 22 4 12"></polyline>
                                <rect x="2" y="7" width="20" height="5"></rect>
                                <line x1="12" y1="22" x2="12" y2="7"></line>
                                <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
                                <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
                            </svg>
                        </div>
                        <div className='m_card_bottom'> 
                            <div className='m_card_title'>Clone a Cloth</div>
                            <div className='m_card_desc'>Have a favorite outfit that fits you perfectly?</div>
                            <button className="m_card_btn">Select</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    );
}

export default Measurement_sel_page;